import { createSlice } from '@reduxjs/toolkit'
import { WorkflowReduxInitialState } from '../types'

const initialState: WorkflowReduxInitialState = {
  workflowEntityRelationshipTree: [],
  workflowDefinition: null,
  workflowInstance: null,
  workflowInstanceAdditionalKeys: null,
  relationshipTree: [],
  relationShipTreeObject: null,
  caseDetails: null,
  automationStagedDetails: null,
  faxDetails: null,
  intakeCommunicationMap: null,
  caseData: null,
  taskList: null,
  patientData: null,
  unresolvedDedupeEntities: [],
}

const workflowSlice = createSlice({
  name: 'workflow',
  initialState: initialState,
  reducers: {
    updateWorkflowEntityRelationshipTree: (state, action) => {
      state.workflowEntityRelationshipTree = action?.payload || []
    },
    updateWorkflowInstance: (state, action) => {
      state.workflowInstance = action?.payload
    },
    updateWorkflowDefinition: (state, action) => {
      state.workflowDefinition = action?.payload
    },
    updateWorkflowInstanceAdditionalKeys: (state, action) => {
      state.workflowInstanceAdditionalKeys = action?.payload
    },
    updateRelationshipTree: (state, action) => {
      state.relationshipTree = action?.payload
    },
    updateRelationshipTreeObject: (state, action) => {
      state.relationShipTreeObject = action?.payload
    },
    updateCaseInfo: (state, action) => {
      state.caseDetails = action.payload
    },
    updateAutomationStagedDetails: (state, action) => {
      state.automationStagedDetails = action.payload
    },
    updateIntakeCommunicationMap: (state, action) => {
      state.intakeCommunicationMap = action.payload
    },
    updateFaxDetailsReducer: (state, action) => {
      state.faxDetails = action.payload
    },
    updateCaseData: (state, action) => {
      state.caseData = action.payload
    },
    updateTaskList: (state, action) => {
      state.taskList = action.payload
    },
    updateWorkflowPatientData: (state, action) => {
      state.patientData = action.payload
    },
    setUnresolvedDedupeEntities: (state, action) => {
      state.unresolvedDedupeEntities = action.payload
    },
    resetWorkflowState: (state) => ({
      ...initialState,
      intakeCommunicationMap: state.intakeCommunicationMap,
    }),
    resetCompleteWorkflowState: () => ({
      ...initialState,
    }),
  },
})

export const {
  updateWorkflowEntityRelationshipTree,
  updateWorkflowDefinition,
  updateWorkflowInstance,
  updateRelationshipTree,
  updateRelationshipTreeObject,
  updateIntakeCommunicationMap,
  resetWorkflowState,
  updateCaseInfo,
  updateFaxDetailsReducer,
  updateCaseData,
  updateTaskList,
  updateWorkflowPatientData,
  updateAutomationStagedDetails,
  updateWorkflowInstanceAdditionalKeys,
  setUnresolvedDedupeEntities,
  resetCompleteWorkflowState,
} = workflowSlice.actions
export default workflowSlice.reducer
